import { Button, Col, Row } from "reactstrap";

import { AbilityContext } from "@context/can";
import ErrorBoundaryWrapper from "@views/common/error-boundary-wrapper";
import classNames from "classnames";
import size from "lodash/size";
import { useContext } from "react";
import useWindowSize from "@hooks/use-window-size";

function FieldArrays (props) {
    const {
        fields,
        render,
        subject,
        handleAppend,
        handleRemove,
        disabledAppend = false,
        disabledRemove = false,
        className = "",
        alignItems = "center",
        justify = "start",
        actionColumnSize = 2,
        extraActions = () => <></>
    } = props;

    const ability = useContext(AbilityContext);
    const { isMobileView } = useWindowSize();
    const canUpdate = subject ? ability.can("update", subject) : true;
    const showAppend = (index) => size(fields) === index + 1 && !disabledAppend && canUpdate;
    const showRemove = size(fields) > 1 && !disabledRemove && canUpdate;

    return (
        <ErrorBoundaryWrapper
            name="fields"
            children={fields.map((item, index) => (
                <Row
                    key={item.id}
                    className={classNames(
                        "mb-25",
                        {
                            "flex-column align-items-center": isMobileView,
                            [`justify-content-${justify}`]  : justify
                        },
                        [className]
                    )}>
                    {render(index)}
                    {(showAppend(index) || (showRemove && !item.hideRemove) || extraActions(index)) && (
                        <Col
                            xl={actionColumnSize}
                            lg={12}
                            className={classNames(
                                "d-flex justify-content-start gap-1",
                                {
                                    "w-100"                      : isMobileView,
                                    [`align-items-${alignItems}`]: true
                                }
                            )}>
                            <>
                                {extraActions(index)}
                                {showAppend(index) && (
                                    <Button
                                        color="primary"
                                        onClick={() => handleAppend && handleAppend(index + 1)}
                                        data-cy={`add-btn-${index}`}
                                        className="p-25">
                                        <i className="mdi mdi-plus font-medium-5" />
                                    </Button>
                                )}
                                {showRemove && !item.hideRemove && (
                                    <Button
                                        color="danger"
                                        onClick={() => handleRemove && handleRemove(index)}
                                        data-cy={`delete-btn-${index}`}
                                        className="p-25">
                                        <i className="mdi mdi-delete-forever font-medium-5" />
                                    </Button>
                                )}
                            </>
                        </Col>
                    )}
                </Row>
            ))}/>
    );
}

export default FieldArrays;
